import React, { useEffect, useState } from "react";
import umw from "./images/umw.svg";
import neoVinci from "./images/logo_neo.svg";
import pharmindex from "./images/pharmindex.svg";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import { ROUTES_CORE } from "commons/constants/paths";
import {
  StyledNavbarList,
  StyledNavbarListItem,
  StyledLoginButton,
  StyledFooter,
  StyledFooterDescription,
  StyledFooterSection,
  StyledFooterImg,
  StyledFooterImgSpan,
  StyledFooterDescriptionContact,
  StyledMainPage,
} from "./Home.styled";
import { useAppDispatch, useAppSelector } from "commons/store/hooks";
import MedicalCenter from "../components/MedicalCenter";
import { PROJECT_EMAIL, PROJECT_NAME, PROJECT_PHONE } from "commons/constants/env";
import { fetchPageData, selectPageData } from "../../../redux/pageSlice";

function Home() {
  const dispatch = useAppDispatch();
  const page = useAppSelector(selectPageData);
  const [isDataLoading, setDataLoading] = useState(false);

  /**
   * Used to fetch page data
   */
  const fetchData = async () => {
    setDataLoading(true);

    const page = await dispatch(fetchPageData('home'))?.unwrap();

    if (!page) {
      return;
    }

    setDataLoading(false);
  }

  useEffect(() => {
    fetchData().then();

    /** clear state after unmount */
    // return () => {
    //   dispatch(resetEcrf());
    // };
  }, []);

  /** Tab title controller */
  useEffect(() => {
    document.title = `${PROJECT_NAME} - Strona Główna`;
    return () => {
      document.title = PROJECT_NAME;
    };
  }, [dispatch]);

  return (
    <StyledMainPage>
      {isDataLoading && (
        <Box display="grid" style={{placeItems: 'center', height: '100vh'}}>
          <Box display="grid" style={{placeItems: 'center', gap: '15px'}}>
            <CircularProgress />
          </Box>
        </Box>
      )}

      {!isDataLoading && (<>
      <header>
        <Container maxWidth="lg">
          <Grid container spacing={0} direction="row" justifyContent="space-between" alignItems="center" style={{ minHeight: '70px' }}>
            <Grid container item lg={3} xs={12} spacing={0}>
              {/* <StyledRefsalLogo src={imprv} alt="Projekt Refsal logo" /> */}
            </Grid>
            <Grid container item lg={9} xs={12} spacing={0}>
              <StyledNavbarList>
                <StyledNavbarListItem>
                  <Button size="medium">Information about trial</Button>
                </StyledNavbarListItem>
                <StyledNavbarListItem>
                  <Button size="medium">Trial site(s)</Button>
                </StyledNavbarListItem>
                <StyledNavbarListItem>
                  <Button size="medium">Contact</Button>
                </StyledNavbarListItem>
                <StyledNavbarListItem>
                  {/*<StyledLoginButton*/}
                  {/*  variant="outlined"*/}
                  {/*  color="#1D3E73"*/}
                  {/*  style={{borderWidth: "2px", borderColor: "#1D3E73", color: "#1D3E73"}}*/}
                  {/*  to={ROUTES_CORE.LOGIN}*/}
                  {/*  component={Link}*/}
                  {/*>*/}
                  {/*  SIGN IN*/}
                  {/*</StyledLoginButton>*/}
                </StyledNavbarListItem>
              </StyledNavbarList>
            </Grid>
          </Grid>
        </Container>
      </header>

      <Box style={{placeItems: 'center'}} width={'100%'} mt={24} mb={24} display={'grid'}>
        <Box fontSize={'50px'} textAlign={'center'}>Neo-Vinci ECRF Home Template</Box>
      </Box>

      <section>
        <Container maxWidth="lg">
          <MedicalCenter />
        </Container>
      </section>
      <StyledFooter>
        <Container maxWidth="lg">
          <StyledFooterSection>
            <StyledFooterDescription>
              Lorem ipsum
            </StyledFooterDescription>
            <StyledFooterDescriptionContact>
              e-mail: ${PROJECT_EMAIL} | phone: ${PROJECT_PHONE} <br/>
              <br/>
              Working days: Monday-Friday, hours: 9:00-17:00
            </StyledFooterDescriptionContact>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} sm={6} md={4} lg={2}>
                {/*<StyledFooterImg src={headerImg} alt="Projekt Empathy logo"/>*/}
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImg src={'./images/logo-abm.svg'} alt="ABM logo"/>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={1} style={{marginRight: "40px", marginLeft: "40px"}}>
                <StyledFooterImg src={umw} alt="UMW logo"/>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2} style={{marginRight: "40px"}}>
                <StyledFooterImg src={pharmindex} alt="Pharmindex logo"/>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImgSpan>Technical organizator:</StyledFooterImgSpan>
                <StyledFooterImg src={neoVinci} alt="Neo-Vinci logo"/>
              </Grid>
            </Grid>
          </StyledFooterSection>
        </Container>
      </StyledFooter>
      </>
    )}
    </StyledMainPage>
  );
}

export default Home;
